module.exports = __webpack_public_path__ + "img/JP.281ba5ff.png";